export const homeBannerIniValues = {
  title: "",
  banner: "",
  _id: "",
  colorText: "",
  mobileBanner:""
};
